import React from 'react';
import { Select, MenuItem, FormControl, InputLabel, Chip, Box } from '@mui/material';

const Selector = ({ 
  value, 
  onChange, 
  options = [], 
  placeholder = 'Seleccionar...', 
  multiple = false,
  error = false,
  label,
  ...props 
}) => {
  return (
    <FormControl fullWidth error={error} {...props}>
      {label && <InputLabel>{label}</InputLabel>}
      <Select
        value={value || (multiple ? [] : '')}
        onChange={onChange}
        multiple={multiple}
        displayEmpty
        label={label}
        renderValue={(selected) => {
          if (multiple) {
            if (!selected || selected.length === 0) {
              return <em style={{ color: '#999' }}>{placeholder}</em>;
            }
            return (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((val) => {
                  const option = options.find(opt => {
                    const optVal = typeof opt === 'string' ? opt : opt.value || opt.label;
                    return optVal === val;
                  });
                  const label = typeof option === 'string' ? option : option?.label || option?.value || val;
                  return <Chip key={val} label={label} size="small" />;
                })}
              </Box>
            );
          }
          if (!selected) {
            return <em style={{ color: '#999' }}>{placeholder}</em>;
          }
          const option = options.find(opt => {
            const optVal = typeof opt === 'string' ? opt : opt.value || opt.label;
            return optVal === selected;
          });
          return typeof option === 'string' ? option : option?.label || option?.value || selected;
        }}
        sx={{
          backgroundColor: '#F8F9FA',
          borderRadius: 1,
        }}
      >
        {!multiple && (
          <MenuItem value="" disabled>
            <em>{placeholder}</em>
          </MenuItem>
        )}
        {options.map((option) => {
          const optionValue = typeof option === 'string' ? option : option.value || option.label;
          const optionLabel = typeof option === 'string' ? option : option.label || option.value;
          return (
            <MenuItem key={optionValue} value={optionValue}>
              {optionLabel}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default Selector;

